import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.viewer;

export const viewersListSelector = createSelector(getState, (state) => state.viewers);
export const viewersMetaDataSelector = createSelector(getState, (state) => state.metaData);
export const isLoadingViewersSelector = createSelector(getState, (state) => state.isLoadingViewers);
